module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: {
      'remittance-detail': _vm.showRemovalButton
    },
    attrs: {
      "id": "tab-remittance-report"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showGrid),
      expression: "showGrid"
    }],
    staticClass: "margin-container col-md-12"
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "remittanceReportGrid",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "resumoRemesDisposaIntegracao",
      "cfgObj": _vm.treeGridCfg,
      "treeGridModal": true,
      "showHrTopGrid": false
    }
  })], 1)]), (_vm.showRemovalButton) ? _c('div', {
    staticClass: "tab-footer"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('remessaIntegracao.titulos.excluirRemessa'),
      "id": "btnExcluirArquivo",
      "clickFunction": _vm.openModalConfirm
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6fc77e22", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fc77e22"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/integration/remittanceIntegration/tabRemittanceReport.pug
// module id = 1432
// module chunks = 0